import type { RcpaProductVersionFormat } from './model.ts'

export const rcpaProductVersions = [
  /**
   * Initial version.
   */
  'product-fr-rcp-aig-1.0.0-2026-03-13',
] as const satisfies RcpaProductVersionFormat[]
export type RcpaProductVersion = (typeof rcpaProductVersions)[number]
